import { createAction } from '@reduxjs/toolkit';

export const dataPointersCleanUp = createAction('dataPointersCleanUp');

export const dataPointersUpdate = createAction('dataPointersUpdate');
